
function calculator() {

    //čistá mzda
    var y = document.getElementById("y-id");
    var yDefaultVal = y.defaultValue;
    var yCurrentVal = y.value;

    //pevný základ
    var x = Math.floor(6154.67);

    //počet dětí
    var m = document.getElementById("pocet-deti");
    var mCurrentVal = m.value;

    //příspěvěk k počtu dětí
    var n = x / 4 * mCurrentVal;

    //příspěvěk k manželství
    if (document.getElementById("manzelstvi").checked) {
        var p = x / 4 * 1;
    } else {
        var p = 0;
    }

    // měsíční splátka = čistá mzda - pevný základ - manželství - děti
    if (x >= yCurrentVal) {
        var z = 0;
    } else {
        var z = Math.floor(2 / 3 * (yCurrentVal - Math.ceil(x + n + p)));
    }

    if (Math.ceil(x + n + p) < yCurrentVal) {
        var h = z;
    } else {
        var h = 0;
    }

    //mzda k výplatě => hodnota čísté mzdy - hodnota měsíční splátky
    var b = yCurrentVal - h



    // mzda k výplatě => když je mzda k výplatě vyšší než horní hranice vypiš max. možnou mzdu k výplatě a započítej tam počet vyživovaných osob, dále uprav měsíční splátku (odečteš mzdu k výplatě s podmínkou od čísté mzdy)
    var maxLimit = 9338

    if (b > maxLimit) {
        var j = Math.ceil(maxLimit + n + p);
        // když je čistá mzda - mzda k výpláte větší nebo rovna 0, tak splátka je odečtení mzdy k vyplátě od čisté mzdy, pokud ne splátka je rovna 0 a mzda k výplatě se rovná čisté mzdě
        if (yCurrentVal - j >= 0) {
            var h = yCurrentVal - j;
        }
        else {
            var h = 0;
            var j = yCurrentVal;
        }
    }
    else {
        var j = b;
    }


    //splaceno za pět let
    var k = h * 60;

    //maximální možný dluh
    var l = k / 3 * 10;

    //kolik usetrite
    var u = l - k;


    document.getElementById("splatka").innerHTML = h.toLocaleString() + " Kč";
    document.getElementById("mzda-k-vyplate").innerHTML = j.toLocaleString() + " Kč";
    document.getElementById("pet-let").innerHTML = k.toLocaleString() + " Kč";
    document.getElementById("max-dluh").innerHTML = l.toLocaleString() + " Kč";
    document.getElementById("usetri").innerHTML = u.toLocaleString() + " Kč";

    var total = h + j + k + l + u;

    google.charts.load('current', { 'packages': ['corechart'] });
    google.charts.setOnLoadCallback(drawChart);

    function drawChart() {

        var data = google.visualization.arrayToDataTable([
            ['Task', 'Kč'],
            ['Měsíční splátka pro oddlužení', h],
            ['Mzda k výplatě', j],
            ['Celková výše splátek pro oddlužení za pět let', k],
            ['Maximální výše dluhu', l],
            ['Kolik ušetříte', u]
        ]);

        var options = {
            title: '',
            legend: { position: 'bottom', maxLines: 0 },
            tooltip: { text: 'percentage'}
        };

        var chart = new google.visualization.PieChart(document.getElementById('piechart'));

        chart.draw(data, options);
    }
}
